import { useGlobalStore as o } from "@sunrise/shared";
import { defineComponent as i, computed as c } from "vue";
import m from "./index15.js";
const f = i({
  name: "CsDsaReportLink",
  components: {
    CsCopyTextLink: m
  },
  props: {
    text: {
      type: String,
      default: "Inhalt melden"
    },
    reference: {
      type: String,
      required: !0
    },
    channel: String
  },
  setup(t) {
    const e = o().requestContext;
    return {
      computedLink: c(() => {
        const n = e == null ? void 0 : e.globalLinks.dsaReportForm;
        return n ? p(n, t.reference, t.channel) : "";
      })
    };
  }
});
function p(t, e, r) {
  let n = `${t}?reference=${encodeURIComponent(e)}`;
  return r && (n += `&channel=${encodeURIComponent(r)}`), n;
}
export {
  f as default
};
